export class DataProtectionNoticeListLoad {
  public static readonly type = '[DataProtectionNoticeList] Load';
}

export class DataProtectionNoticeListInitialState {
  public static readonly type = '[DataProtectionNoticeList] Set Initial State';
}
